import { useEffect } from "react";

const SITE_URL = "https://hireds.in";

/**
 * Injects <link rel="prev"> / <link rel="next"> tags into <head>
 * for paginated listing pages. Cleans up on unmount or page change.
 *
 * @param {string} basePath - e.g. "/all-india-jobs"
 * @param {URLSearchParams|object} extraParams - filter params (excluding page)
 * @param {number} page - current 1-indexed page number
 * @param {number} totalPages - total pages
 */
export default function usePaginationLinks(basePath, extraParams, page, totalPages) {
  useEffect(() => {
    if (!totalPages || totalPages < 2) return;
    const sp = new URLSearchParams(extraParams || {});
    sp.delete("page");

    const buildUrl = (p) => {
      const s = new URLSearchParams(sp);
      if (p > 1) s.set("page", String(p));
      const qs = s.toString();
      return `${SITE_URL}${basePath}${qs ? `?${qs}` : ""}`;
    };

    const ensure = (rel) => {
      let el = document.head.querySelector(`link[rel="${rel}"][data-pagination="1"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        el.setAttribute("data-pagination", "1");
        document.head.appendChild(el);
      }
      return el;
    };
    const remove = (rel) => {
      const el = document.head.querySelector(`link[rel="${rel}"][data-pagination="1"]`);
      if (el) el.remove();
    };

    if (page > 1) {
      ensure("prev").setAttribute("href", buildUrl(page - 1));
    } else {
      remove("prev");
    }
    if (page < totalPages) {
      ensure("next").setAttribute("href", buildUrl(page + 1));
    } else {
      remove("next");
    }

    return () => {
      remove("prev");
      remove("next");
    };
  }, [basePath, page, totalPages, JSON.stringify(extraParams || {})]); // eslint-disable-line
}
